<i class="icon-content-filter-remove" [title]="translationKeys.AvanoTable.TableHeader.ResetAllFilters | translate"></i>
